require([
],
    function () { 

        function initTooltips() {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        }

        function compareProducts() {
            if ($('.product-sizing-component').length == 1) return;
            $('.product-comparison-table td[data-product-code]').hide();
            $('.product-comparison-table th[data-product-code]').hide();
            $('.read-comparison-table').hide();
            var counter = 0;
            $('input[data-compare-product]:checked').each(function () {
                var productCode = $(this).data("compareProduct");
                $('.product-comparison-table td[data-product-code="' + productCode + '"]').show();
                $('.product-comparison-table th[data-product-code="' + productCode + '"]').show();
                $('.product-comparison-table td[data-product-code=""]').show();
                $('.product-comparison-table th[data-product-code=""]').show();
                $(this).closest("div").find(".read-comparison-table").show();
                counter++;
            });
            if (counter == 0)
                $(".product-sizing-comparison").hide();
            else
                $(".product-sizing-comparison").show();

            if (counter >= 3) {
                $("input[data-compare-product]:checkbox:not(:checked)").each(function () {
                    this.disabled = true;
                });
            }
            else {
                $("input[data-compare-product]:checkbox:not(:checked)").each(function () {
                    this.disabled = false;
                });
            }
        }

        function initProductsCompare() {
            $('input[data-compare-product]:checkbox').change(function () {
                compareProducts();
            });
        }

        compareProducts();
        initProductsCompare();   
        initTooltips();
});

define("ProductSizing/main", function(){});

